import { render, staticRenderFns } from "./CmsList.vue?vue&type=template&id=1b9827ee&scoped=true"
import script from "./CmsList.vue?vue&type=script&lang=js"
export * from "./CmsList.vue?vue&type=script&lang=js"
import style0 from "./CmsList.vue?vue&type=style&index=0&id=1b9827ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9827ee",
  null
  
)

export default component.exports